import React from 'react'

const NiAccount = () => {
    return (
        <svg width="24" height="24" class="mb-4 text-text-primary" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 21L16.8283 21.4635C13.6193 21.8201 10.3807 21.8201 7.17167 21.4635V21.4635C4.73277 21.1925 2.80747 19.2672 2.53648 16.8283V16.8283C2.17992 13.6193 2.17992 10.3807 2.53648 7.17167L3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path><path opacity="0.6" d="M6 15L9 12C10.1046 10.8954 11.8954 10.8954 13 12V12C14.1046 13.1046 15.8954 13.1046 17 12L20 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
    )
}

export default NiAccount
